import { computed, observable } from 'mobx';
import Abstract from './abstract';

const KEY_MAP = { uuid: 'value', name: 'label' };

export class Album extends Abstract {
  @computed get types() {
    const { modules } = alo7Account;
    const items = modules.find(item => item.uuid === 'ALBUM').subModules;
    return nx.keyMap(items, KEY_MAP).map(({ value, label }) => ({ value, label }));
  }
}
